import React, { Component } from "react";
import { withRouter } from 'react-router-dom';
import { connect } from 'react-redux';
import PropTypes from "prop-types";
import { withStyles } from "@material-ui/core";
import { messageShow } from "../../common/api/actions";
import BrandedLoading from "../../common/BrandedLoading";
import SectionPaper from "../../common/SectionPaper";
import { nullToEmptyString } from "../../../setup/helpers";
import { Typography, Button, TextField, Toolbar, IconButton, MenuItem, Box } from "@mui/material";
import Grid from "@material-ui/core/Grid/Grid";
import ArrowBack from '@mui/icons-material/ArrowBack';
import AddIcon from '@mui/icons-material/Add';
import DeleteIcon from '@mui/icons-material/Delete';
import SmartToyIcon from '@mui/icons-material/SmartToy';
import PsychologyIcon from '@mui/icons-material/Psychology';
import LightbulbOutlinedIcon from '@mui/icons-material/LightbulbOutlined';
import ChevronRightIcon from '@mui/icons-material/ChevronRight';
import styles from "./styles";

import routes from "../api/routes";
import { createOrUpdateIntent, generateSuggestions } from "../api/actions/mutation";
import { getIntentById, getbotSettings } from '../api/actions/query';

class CreateOrUpdate extends Component {
  constructor(props) {
    super(props);
    this.intents = {
      _id: "",
      intent: "",
      utterances: [],
      responses: [],
      choices: [],
      knowledgeCategoryId: this.props.location?.state?.knowledgeCategoryId || null,
      api: {
        url: "",
        method: "",
        requestPayload: "",
        responseKey: ""
      }
    };
    this.state = {
      intents: this.intents,
      isLoading: false,
      isLoadingSubmit: false,
      isGenerating: false,
      lastAddedType: null
    };
  }

  componentDidMount() {
    this.fetchBotSettings();
    const {
      match: {
        params: { intentId },
      },
    } = this.props;

    if (intentId) {
      this.getIntent(intentId);
    }
  }

  getIntent = async (intentId) => {
    const { messageShow, getIntentById } = this.props;
    this.isLoadingToggle(true);

    try {
      const { data } = await getIntentById({ intentId });
      if (data.success) {
        this.setState({
          intents: {
            ...data.data,
            utterances: Array.isArray(data.data.utterances) ? data.data.utterances : [],
            responses: Array.isArray(data.data.responses) ? data.data.responses : [],
            choices: Array.isArray(data.data.choices) ? data.data.choices : [],
          }
        })
      }
    } catch (error) {
      console.error("Error fetching intent data:", error);
      messageShow("There was some error. Please try again.");
    } finally {
      this.isLoadingToggle(false);
    }
  };

  fetchBotSettings = async () => {
    // No longer need to fetch API key in frontend
  };

  onGenerateWithAI = async () => {
    const { intents } = this.state;
    const { messageShow, generateSuggestions } = this.props;

    this.setState({ isGenerating: true });

    try {
      const { data } = await generateSuggestions({ intentName: intents.intent });

      if (data.success && data.data) {
        const result = data.data;
        this.setState((prevState) => ({
          intents: {
            ...prevState.intents,
            intent: prevState.intents.intent || result.intent || "",
            utterances: [...prevState.intents.utterances, ...(result.utterances || [])],
            responses: [...prevState.intents.responses, ...(result.responses || [])]
          }
        }));
        messageShow(result.intent ? `Suggested intent: "${result.intent}"` : "Smart suggestions added!");
      } else {
        messageShow(data.message || "Failed to generate suggestions.");
      }
    } catch (error) {
      console.error("AI Generation Error:", error);
      messageShow("Failed to generate with Smart. Please check server logs.");
    } finally {
      this.setState({ isGenerating: false });
    }
  };

  onCreateOrUpdate = async (event) => {
    event.preventDefault();
    const { createOrUpdateIntent, messageShow, history } = this.props;
    const { intents } = this.state;
    this.isLoadingSubmitToggle(true);
    
    try {
      const payload = { ...intents };
      delete payload.richContent; // Ensure richContent is not sent if it somehow exists in state
      const { data } = await createOrUpdateIntent(payload);
      this.isLoadingSubmitToggle(false);
      messageShow(data.message);

      if (data.success) {
        history.push(routes.intentsList.path);
      }
    } catch (error) {
      this.isLoadingSubmitToggle(false);
      console.error("Error during submission:", error);
      messageShow("Some error occurred. Please try again.");
    }
  };

  isLoadingToggle = (isLoading) => {
    this.setState({
      isLoading,
    });
  };

  isLoadingSubmitToggle = (isLoadingSubmit) => {
    this.setState({
      isLoadingSubmit,
    });
  };

  onType = (event) => {
    const { name, value } = event.target;

    this.setState((prevState) => ({
      intents: {
        ...prevState.intents,
        [name]: value,
      },
    }));
  };

  handleArrayChange = (index, type, value) => {
    const { intents } = this.state;
    const newArray = [...intents[type]];
    newArray[index] = value;
    
    this.setState((prevState) => ({
      intents: {
        ...prevState.intents,
        [type]: newArray,
      },
    }));
  };

  handleAdd = (type) => {
    this.setState((prevState) => ({
      intents: {
        ...prevState.intents,
        [type]: [...prevState.intents[type], ""],
      },
      lastAddedType: type,
    }));
  };

  handleKeyDown = (event, index, type) => {
    if (event.key === 'Enter') {
      event.preventDefault();
      this.handleAdd(type);
    }
  };

  handleRemove = (index, type) => {
    const { intents } = this.state;
    const newArray = intents[type].filter((_, i) => i !== index);

    this.setState((prevState) => ({
      intents: {
        ...prevState.intents,
        [type]: newArray,
      },
    }));
  };

  onApiChange = (event) => {
    const { name, value } = event.target;
    this.setState((prevState) => ({
      intents: {
        ...prevState.intents,
        api: {
          ...prevState.intents.api,
          [name]: value,
        },
      },
    }));
  };

  renderPreview = () => {
    const { classes } = this.props;
    const { intents } = this.state;

    const utterances = intents.utterances && intents.utterances.length > 0 ? intents.utterances : [];
    const firstResponse = intents.responses && intents.responses.length > 0 ? intents.responses[0] : null;

    return (
      <div className={classes.previewContainer}>
        <div className={classes.previewCard}>
          <div className={classes.previewHeader}>
            <SmartToyIcon />
            <Typography variant="h6" style={{ fontWeight: 600 }}>Intent Preview</Typography>
          </div>

          <div className={classes.stepContainer}>
            {/* Step 1: User Input (All Utterances) */}
            <div className={classes.stepItem}>
              <div className={classes.stepNumber}>1</div>
              <div className={classes.stepContent}>
                <div className={classes.stepLabel}>User Utterances (Training Data)</div>
                <div style={{ display: 'flex', flexDirection: 'column', gap: '8px' }}>
                  {utterances.length > 0 ? (
                    utterances.map((utt, index) => (
                      <div key={index} className={`${classes.chatBubble} ${classes.userBubble}`} style={{ width: 'fit-content' }}>
                        {utt || <span className={classes.placeholderText}>Empty utterance...</span>}
                      </div>
                    ))
                  ) : (
                    <div className={`${classes.chatBubble} ${classes.userBubble}`}>
                      <span className={classes.placeholderText}>"Enter utterances to see them here..."</span>
                    </div>
                  )}
                </div>
              </div>
            </div>

            {/* Step 2: Recognition */}
            <div className={classes.stepItem}>
              <div className={classes.stepNumber}>2</div>

              <div className={classes.stepContent}>
                <div className={classes.stepLabel}>Recognition</div>
                <div style={{ display: 'flex', alignItems: 'center', gap: '10px' }}>
                  <PsychologyIcon style={{ color: '#1976d2' }} />
                  <div className={classes.intentBadge}>
                    {intents.intent || "unknown_intent"}
                  </div>
                </div>
              </div>
            </div>

            {/* Step 3: Bot Response */}
            <div className={classes.stepItem}>
              <div className={classes.stepNumber}>3</div>
              <div className={classes.stepContent}>
                <div className={classes.stepLabel}>Bot Response</div>
                <div className={`${classes.chatBubble} ${classes.botBubble}`}>
                  {firstResponse || <span className={classes.placeholderText}>"Enter a response to see it here..."</span>}
                  
                  {intents.choices && intents.choices.length > 0 && (
                    <Box sx={{ display: 'flex', flexWrap: 'wrap', gap: 1, mt: 1.5 }}>
                      {intents.choices.map((choice, i) => (
                        <Button 
                          key={i} 
                          size="small" 
                          variant="outlined" 
                          className={classes.choiceButton}
                          style={{
                            borderColor: choice.link ? '#4caf50' : undefined,
                            color: choice.link ? '#2e7d32' : undefined
                          }}
                          endIcon={choice.link ? <ChevronRightIcon fontSize="small" /> : null}
                        >
                          {choice.text || `Option ${i + 1}`}
                        </Button>
                      ))}
                    </Box>
                  )}
                </div>
              </div>
            </div>

          </div>
        </div>

        <div style={{ marginTop: '24px', padding: '16px', backgroundColor: '#e8f5e9', borderRadius: '12px', border: '1px solid #c8e6c9' }}>
           <Typography variant="subtitle2" style={{ color: '#2e7d32', fontWeight: 600, display: 'flex', alignItems: 'center', gap: '8px' }}>
              <AddIcon fontSize="small" /> Live Update Enabled
           </Typography>
           <Typography variant="body2" style={{ color: '#4caf50', marginTop: '4px' }}>
              The preview updates in real-time as you type your configurations on the left.
           </Typography>
        </div>
      </div>
    );
  };

  renderHelper = () => {
    return (
      <Box sx={{ mt: 3 }}>
        <Box 
          sx={{ 
            backgroundColor: '#F8F9FE', 
            borderRadius: '12px', 
            border: '1px solid #E9ECEF',
            p: 3
          }}
        >
          <Box display="flex" alignItems="center" mb={2} sx={{ color: '#5E72E4' }}>
            <LightbulbOutlinedIcon sx={{ mr: 1, fontSize: 20 }} />
            <Typography variant="subtitle2" sx={{ fontWeight: 700, letterSpacing: '0.5px', textTransform: 'uppercase' }}>
              INTENT EDITOR QUICK TIPS
            </Typography>
          </Box>

          <Grid container spacing={2}>
            <Grid item xs={12}>
              <Box display="flex" alignItems="flex-start">
                <ChevronRightIcon sx={{ color: '#5E72E4', fontSize: 18, mt: '2px', mr: 1, flexShrink: 0 }} />
                <Typography variant="body2" sx={{ color: '#525F7F', lineHeight: 1.6 }}>
                  <span style={{ fontWeight: 600, color: '#32325D' }}>Auto Generate:</span> Use the button in the toolbar to automatically suggest utterances and responses based on your intent name.
                </Typography>
              </Box>
            </Grid>

            <Grid item xs={12}>
              <Box display="flex" alignItems="flex-start">
                <ChevronRightIcon sx={{ color: '#5E72E4', fontSize: 18, mt: '2px', mr: 1, flexShrink: 0 }} />
                <Typography variant="body2" sx={{ color: '#525F7F', lineHeight: 1.6 }}>
                  <span style={{ fontWeight: 600, color: '#32325D' }}>Utterances:</span> Add at least 5-10 varied examples of how a user might express this intent to improve recognition.
                </Typography>
              </Box>
            </Grid>

            <Grid item xs={12}>
              <Box display="flex" alignItems="flex-start">
                <ChevronRightIcon sx={{ color: '#5E72E4', fontSize: 18, mt: '2px', mr: 1, flexShrink: 0 }} />
                <Typography variant="body2" sx={{ color: '#525F7F', lineHeight: 1.6 }}>
                  <span style={{ fontWeight: 600, color: '#32325D' }}>Choices:</span> Use choices for guided flows and quick responses.
                </Typography>
              </Box>
            </Grid>
          </Grid>
        </Box>
      </Box>
    )
  }

  render() {
    const {
      match: {
        params: { intentId },
      },
      classes,
    } = this.props;
    const { intents, isLoading, isLoadingSubmit } = this.state;
   
    return (
      <div>
        <Toolbar className={classes.toolbar}>
          <IconButton
            className={classes.menuButton}
            color="inherit"
            onClick={() => this.props.history.push("/intents")}
          >
            <ArrowBack />
          </IconButton>

          <Typography variant="h6" color="inherit" className={classes.grow}>
            {intentId ? "Edit" : "Create"} Intents
          </Typography>
          <Button
            variant="contained"
            color="primary"
            onClick={this.onGenerateWithAI}
            disabled={this.state.isGenerating}
            style={{ textTransform: 'none' }}
          >
            {this.state.isGenerating ? "Generating..." : "Auto Generate"}
          </Button>
        </Toolbar>

        <div style={{ padding: '24px' }}>
          <Grid container spacing={4}>
            <Grid item xs={12} lg={6}>
              <SectionPaper padding>
                {isLoading ? (
                  <BrandedLoading />
                ) : (
                  <form onSubmit={this.onCreateOrUpdate}>

                <Grid item xs={12} style={{ marginBottom: 24, display: 'flex', alignItems: 'center', gap: '16px' }}>
                  <TextField
                    name={"intent"}
                    variant="standard"
                    value={nullToEmptyString(intents?.intent)}
                    onChange={this.onType}
                    label={"Intent Name"}
                    placeholder={"Enter Intent name"}
                    required={true}
                    margin={"dense"}
                    autoComplete={"off"}
                    fullWidth
                    autoFocus
                  />
                </Grid>

                <Grid item xs={12} style={{ marginBottom: 24, padding: '16px', background: '#f9f9f9', borderRadius: '4px' }}>
                  <Typography variant="subtitle1" gutterBottom style={{ fontWeight: 600 }}>Utterances *</Typography>
                  <Typography variant="body2" color="textSecondary" style={{ marginBottom: 16 }}>
                    Add various ways a user might ask for this intent (e.g., "What are your hours?", "Are you open?").
                  </Typography>
                  
                  {(!intents.utterances || intents.utterances.length === 0) && (
                     <div style={{ textAlign: 'center', padding: '20px', color: '#888' }}>
                       No utterances added yet.
                     </div>
                  )}

                  {intents.utterances && intents.utterances.map((utterance, index) => (
                    <Grid container spacing={2} key={index} alignItems="center" style={{ marginBottom: 12 }}>
                      <Grid item xs={11}>
                        <TextField
                          variant="outlined"
                          value={utterance}
                          onChange={(e) => this.handleArrayChange(index, 'utterances', e.target.value)}
                          onKeyDown={(e) => this.handleKeyDown(e, index, 'utterances')}
                          placeholder={`Enter utterance example #${index + 1}`}
                          fullWidth
                          size="small"
                          autoFocus={this.state.lastAddedType === 'utterances' && index === intents.utterances.length - 1}
                        />
                      </Grid>
                      <Grid item xs={1}>
                        <IconButton onClick={() => this.handleRemove(index, 'utterances')} size="small" style={{ color: '#d32f2f' }}>
                          <DeleteIcon />
                        </IconButton>
                      </Grid>
                    </Grid>
                  ))}
                  <Button
                    startIcon={<AddIcon />}
                    onClick={() => this.handleAdd('utterances')}
                    color="primary"
                    variant="contained"
                    size="small"
                    style={{ marginTop: 8 }}
                  >
                    Add Utterance
                  </Button>
                </Grid>

                <Grid item xs={12} style={{ marginBottom: 24, padding: '16px', background: '#f9f9f9', borderRadius: '4px' }}>
                  <Typography variant="subtitle1" gutterBottom style={{ fontWeight: 600 }}>Responses *</Typography>
                  <Typography variant="body2" color="textSecondary" style={{ marginBottom: 16 }}>
                     Draft responses the bot should return (e.g., "We are open 9-5 daily.").
                  </Typography>

                  {(!intents.responses || intents.responses.length === 0) && (
                     <div style={{ textAlign: 'center', padding: '20px', color: '#888' }}>
                       No responses added yet.
                     </div>
                  )}

                  {intents.responses && intents.responses.map((response, index) => (
                    <Grid container spacing={2} key={index} alignItems="center" style={{ marginBottom: 12 }}>
                      <Grid item xs={11}>
                        <TextField
                          variant="outlined"
                          value={response}
                          onChange={(e) => this.handleArrayChange(index, 'responses', e.target.value)}
                          onKeyDown={(e) => this.handleKeyDown(e, index, 'responses')}
                          placeholder={`Enter response variation #${index + 1}`}
                          fullWidth
                          size="small"
                          multiline
                          minRows={1}
                          autoFocus={this.state.lastAddedType === 'responses' && index === intents.responses.length - 1}
                        />
                      </Grid>
                      <Grid item xs={1}>
                        <IconButton onClick={() => this.handleRemove(index, 'responses')} size="small" style={{ color: '#d32f2f' }}>
                          <DeleteIcon />
                        </IconButton>
                      </Grid>
                    </Grid>
                  ))}
                  <Button
                    startIcon={<AddIcon />}
                    onClick={() => this.handleAdd('responses')}
                    color="primary"
                    variant="contained"
                    size="small"
                    style={{ marginTop: 8 }}
                  >
                    Add Response
                  </Button>
                </Grid>

                 {/* Choices Section */}
                  <Grid item xs={12} style={{ marginBottom: 24, padding: '16px', background: '#f9f9f9', borderRadius: '4px' }}>
                  <Typography variant="subtitle1" gutterBottom style={{ fontWeight: 600 }}>Choices</Typography>
                  <Typography variant="body2" color="textSecondary" style={{ marginBottom: 16 }}>
                     Add multi-choice options for the user. 
                     <span style={{ fontWeight: 500, color: '#5E72E4', display: 'block', marginTop: 4 }}>
                       💡 Tip: Use 'Intent' for guided bot flows OR 'Link' to redirect users.
                     </span>
                  </Typography>

                  {(!intents.choices || intents.choices.length === 0) && (
                     <div style={{ textAlign: 'center', padding: '20px', color: '#888' }}>
                       No choices added yet.
                     </div>
                  )}

                  {intents.choices && intents.choices.map((choice, index) => (
                    <div key={index} style={{ marginBottom: 16, padding: '16px 16px 20px 16px', background: '#fff', border: '1px solid #e0e0e0', borderRadius: 8 }}>
                      <Grid container spacing={2} alignItems="center">
                        <Grid item xs={11}>
                          <TextField
                            variant="outlined"
                            label="Button Text"
                            value={choice.text}
                            onChange={(e) => {
                                const newChoices = [...intents.choices];
                                newChoices[index] = { ...newChoices[index], text: e.target.value };
                                this.setState(prevState => ({ intents: { ...prevState.intents, choices: newChoices } }));
                            }}
                            placeholder={`e.g. Visit Website`}
                            fullWidth
                            size="small"
                          />
                        </Grid>
                        <Grid item xs={1} style={{ textAlign: 'right' }}>
                          <IconButton 
                            onClick={() => {
                                 const newChoices = intents.choices.filter((_, i) => i !== index);
                                 this.setState(prevState => ({ intents: { ...prevState.intents, choices: newChoices } }));
                            }} 
                            size="small" 
                            style={{ color: '#d32f2f' }}
                          >
                            <DeleteIcon />
                          </IconButton>
                        </Grid>
                        <Grid item xs={6}>
                          <TextField
                            variant="outlined"
                            label="Intent"
                            value={choice.value}
                            onChange={(e) => {
                                const newChoices = [...intents.choices];
                                newChoices[index] = { ...newChoices[index], value: e.target.value };
                                this.setState(prevState => ({ intents: { ...prevState.intents, choices: newChoices } }));
                            }}
                            placeholder={`e.g. check_hours`}
                            fullWidth
                            size="small"
                            helperText="Internal intent identifier"
                          />
                        </Grid>
                        <Grid item xs={6}>
                          <TextField
                            variant="outlined"
                            label="Link URL"
                            value={choice.link}
                            onChange={(e) => {
                                const newChoices = [...intents.choices];
                                newChoices[index] = { ...newChoices[index], link: e.target.value };
                                this.setState(prevState => ({ intents: { ...prevState.intents, choices: newChoices } }));
                            }}
                            placeholder={`e.g. https://example.com`}
                            fullWidth
                            size="small"
                            helperText="URL to redirect users"
                          />
                        </Grid>
                      </Grid>
                    </div>
                  ))}
                  <Button
                    startIcon={<AddIcon />}
                    onClick={() => {
                        this.setState(prevState => ({
                            intents: { ...prevState.intents, choices: [...(prevState.intents.choices || []), { text: "", value: "", link: "" }] }
                        }));
                    }}
                    color="primary"
                    variant="contained"
                    size="small"
                    style={{ marginTop: 8 }}
                  >
                    Add Choice
                  </Button>
                </Grid>

                <Typography variant="subtitle1" style={{ fontWeight: 500, marginTop: 20, marginBottom: 16 }}>
                     API Details
                </Typography>
                <Grid item xs={12} style={{ marginBottom: 24 }}>
                  <TextField
                     name="url" 
                     label="API URL" 
                     value={intents.api?.url || ""} 
                     onChange={this.onApiChange} 
                     fullWidth 
                  />
                </Grid>
                <Grid item xs={12} style={{ marginBottom: 24 }}>
                  <TextField select name="method" label="Method" value={intents.api?.method || ""} onChange={this.onApiChange} fullWidth>
                     <MenuItem value="GET">GET</MenuItem>
                     <MenuItem value="POST">POST</MenuItem>
                     <MenuItem value="PUT">PUT</MenuItem>
                     <MenuItem value="DELETE">DELETE</MenuItem>
                </TextField>
                </Grid>
                <Grid item xs={12} style={{ marginBottom: 24 }}>
                  <TextField 
                    name="requestPayload" 
                    label="Request Payload (JSON)" 
                    value={intents.api?.requestPayload || ""} 
                    onChange={this.onApiChange} 
                    fullWidth multiline 
                    rows={6} 
                  />
                </Grid>
                <Grid item xs={12} style={{ marginBottom: 24 }}>
                  <TextField 
                     name="responseKey" 
                     label="Response Key" 
                     value={intents.api?.responseKey || ""} 
                     onChange={this.onApiChange} 
                     fullWidth 
                  />
                </Grid>
                 
                <Grid item xs={12} style={{ marginTop: 44 }} className={classes.buttonsContainer}>
                  <Button
                    type={"button"}
                    aria-label={"Close"}
                    variant="outlined"
                    color="secondary"
                    onClick={() => this.props.history.push("/intents")}
                  >
                    Cancel
                  </Button>
                  <Button
                    style={{ marginInlineStart: 12 }}
                    type={"submit"}
                    aria-label={"Save"}
                    color={"primary"}
                    variant="contained"
                    disabled={isLoadingSubmit}
                  >
                    Save
                  </Button>
                </Grid>
              </form>
            )}
          </SectionPaper>
        </Grid>

        {/* Preview Section */}
        <Grid item xs={12} lg={6}>
          {this.renderPreview()}
          {this.renderHelper()}
        </Grid>
      </Grid>
    </div>
  </div>
);
  }
}
CreateOrUpdate.propTypes = {
  messageShow: PropTypes.func.isRequired,
  getIntentById: PropTypes.func.isRequired,
  createOrUpdateIntent: PropTypes.func.isRequired,
  getbotSettings: PropTypes.func.isRequired,
  generateSuggestions: PropTypes.func.isRequired,
};

export default connect(null, { messageShow, createOrUpdateIntent, getIntentById, getbotSettings, generateSuggestions })(
  withRouter(withStyles(styles)(CreateOrUpdate))
);